module.exports = __webpack_public_path__ + "img/one.55a50b19.svg";